import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useAuth } from "../context/AuthContext";
import { ButtonModalOnClickClose } from "../components/ButtonModalSelection";
import Form from "react-bootstrap/Form";

export const UserCertificationDelete = ({
  visible,
  close,
  user,
  certification,
  onComplete,
}) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [responseError, setResponseError] = useState(null);
  const [response, setResponse] = useState(null);
  const [notes, setNotes] = useState("");
  const notesValid = notes !== null && notes.trim() !== "";

  useEffect(() => {
    if (visible) setNotes("");
  }, [visible]);

  const onDelete = async (e) => {
    if (loading) return;
    setResponseError(null);
    e.preventDefault();
    setLoading(true);
    let status = null;
    try {
      const payload = {
        userId: user?.id,
        certificationId: certification?.id,
        issued: null,
        expiration: null,
        notes: notes?.trim(),
      };

      var params = {};
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const response = await authAxios().post(
        "/api/backoffice/certs/user_delete_cert",
        payload,
        config,
      );

      setResponse(response);
      if (response?.request?.status !== null)
        status = response?.request?.status;
      if (response?.status !== null) status = response?.status;
    } catch (err) {
      console.log("error:");
      console.log(err);
    }
    setLoading(false);

    if (status !== null && status === 200) {
      onComplete(true);
      return;
    }

    if (status !== null && status === 409)
      setResponseError("Mismatch user on certificate");

    if (status !== null && status !== 200)
      setResponseError("Certification Not Found");
  };

  return (
    <Modal
      show={visible}
      onHide={close}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          Delete User Certification
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete this certification?
        <br />
        User: {user?.surname}, {user?.forename}
        <br />
        Certification: {certification?.certificate?.name}
        <br />
        Issued: {certification?.issued}
        <Form.Group className="mt-3" controlId="formDeleteNote">
          <Form.Label>Note</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            isInvalid={!notesValid}
            required
            placeholder="Reason for removing this certificate (required)"
          />
          <Form.Control.Feedback type="invalid">
            A note is required.
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Control.Feedback
          type="invalid"
          style={responseError !== null ? { display: "block" } : null}
        >
          {responseError}
        </Form.Control.Feedback>
      </Modal.Body>
      <ButtonModalOnClickClose
        close={close}
        onClickFunc={onDelete}
        funcButtonName={"Delete"}
        loading={loading || !notesValid}
      />
    </Modal>
  );
};
